import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { loadStripe, Stripe } from "@stripe/stripe-js";

import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'loyaltic-stripe-pay',
  templateUrl: './stripe-pay.component.html',
  styleUrls: ['./stripe-pay.component.scss']
})
export class StripePayComponent implements OnInit {

  cculture = '';
  regexPattern = '';
  Id = '';
  PhoneNumber = '';
  
  stripe: Stripe | null = null;

  // Copy this from the dashboard: https://dashboard.stripe.com/test/apikeys
  PUBLISHABLE_KEY: string = "pk_live_7CWTGtlgccfOgD6B1BvBDFv6";

  constructor(private readonly coreService: CoreService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.Id = params.id;
    });
  }

  async ngOnInit(): Promise<void> {
    this.stripe = await loadStripe(this.PUBLISHABLE_KEY);
  }

  checkout(): void {
    let body = {
      id: this.Id
    }
    this.coreService.stripePay(body).then((response:any) => {
      this.stripe.redirectToCheckout({sessionId: response.sessionId})
    })
  }
}
